import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import PrimaryNormal from "../../components/buttons/PrimaryNormal";

export const AppSubmit = ({ title, style, ...otherProps }) => {
  const { handleSubmit } = useFormikContext();

  return (
    <>
      <PrimaryNormal title={title} style={style} onClick={handleSubmit} type="submit" {...otherProps} />
    </>
  );
};

AppSubmit.propTypes = {
  title: PropTypes.string.isRequired,
  style: PropTypes.object,
};
